module.exports = __webpack_public_path__ + "static/hero2-0fcf3fa070ffc0ec27b4b14d8fce3aaa.jpg";